export default "__VITE_ASSET__BMIJbOh___"